import i18n from 'i18next';

export const resources = TRANSLATIONS;

i18n.init({
    resources,
    lng: 'en_US',
    interpolation: {
        escapeValue: false,
    },
    fallbackLng: 'en_US',
    debug: false,
});

export default i18n;
